import React from "react";
import { useTranslation } from "react-i18next";
import { ClearRefinements } from "react-instantsearch-hooks-web";
import RefinementNoCount from "./RefinementNoCount";
import RefinementDateFacet from "./RefinementDateFacet";
import { useUser } from "../context/UserProvider";
import { useTheme } from "../context/ThemeContext";

export default function BoardsFiltersPanel() {
  const { claims } = useUser();
  const { theme: th, isForest } = useTheme();
  const { t } = useTranslation();
  const showDate = !!claims?.admin;
  const [open, setOpen] = React.useState(false);
  const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  React.useEffect(() => { if (!isMobile) setOpen(true); }, [isMobile]);

  const panelStyle = {
    backgroundColor: isForest ? 'rgba(15,58,48,0.6)' : th.surface.card,
    border: `1px solid ${isForest ? 'rgba(255,255,255,0.1)' : th.surface.cardBorder}`,
  };

  return (
    <aside className="space-y-3">
      <button
        type="button"
        className="md:hidden w-full flex items-center justify-between rounded-xl px-3 py-2"
        style={panelStyle}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open ? 'true' : 'false'}
        aria-controls="filters-content-boards"
      >
        <span className="text-sm font-semibold uppercase tracking-wide" style={{ color: isForest ? '#e8f5e9' : th.text.primary }}>{t('converters.filters')}</span>
        <svg width="16" height="16" viewBox="0 0 20 20" aria-hidden className={`transition-transform ${open ? 'rotate-180' : ''}`} style={{ color: isForest ? '#e8f5e9' : th.text.primary }}>
          <path d="M5.5 7.5l4.5 5 4.5-5" fill="none" stroke="currentColor" strokeWidth="2" />
        </svg>
      </button>

      <div id="filters-content-boards" className={`${open ? 'block' : 'hidden'} md:block space-y-4`}>
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold uppercase tracking-wide" style={{ color: isForest ? '#a5d6a7' : th.text.secondary }}>{t('converters.filters')}</h3>
          <ClearRefinements translations={{ resetButtonText: t('converters.clear') }} />
        </div>

        <RefinementNoCount attribute="data.category" title={t('electronics.categories')} />
        {showDate && <RefinementDateFacet title={t('converters.date')} />}
      </div>
    </aside>
  );
}
